import { generateSrcSet } from "./srcset";
function preloadImage(image) {
  const preloadLink = document.createElement("link");
  preloadLink.rel = "preload";
  preloadLink.as = "image";
  preloadLink.imageSrcset = generateSrcSet(image);
  document.head.insertAdjacentElement("beforeend", preloadLink);
}
export {
  preloadImage
};
